import { createContext, useContext, type ReactNode } from 'react';
import { Theme } from 'app/lib/constants';

const THEME_CLASSES: Record<Theme, string> = {
    [Theme.LIGHT]: 'theme-light',
    [Theme.DARK]: 'theme-dark',
    [Theme.HELP]: 'theme-help',
    [Theme.HIGHLIGHT]: 'theme-highlight',
    [Theme.TOOLTIP]: 'theme-tooltip'
};

const ThemeContext = createContext<Theme>(Theme.LIGHT);

export function useTheme(defaultTheme: Theme = Theme.LIGHT) {
    const theme = useContext(ThemeContext) ?? defaultTheme;
    const themeClassname = THEME_CLASSES[theme];

    return { theme, themeClassname };
}

interface ThemeProviderProps {
    theme: Theme;
    children: ReactNode;
}

export function ThemeProvider({ theme, children }: ThemeProviderProps) {
    return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
}
